import React, { useEffect, useState } from "react";

const DialogBox = ({ isOpen, onClose, title, children, className = "", actionButton = null, showIcon = true, disableBackdropClick = false, contentClassName = "max-h-[60vh] overflow-y-auto" }) => {
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Disable scrolling when dialog opens
            document.body.style.overflow = 'hidden';

            // Re-enable scrolling when dialog closes
            return () => {
                document.body.style.overflow = 'auto';
            };
        }
    }, [isOpen]);

    const handleMouseDown = (e) => {
        // Only set dragging if the click started on the overlay
        if (e.target === e.currentTarget) {
            setIsDragging(true);
        }
    };

    const handleMouseUp = (e) => {
        // Only close if we were dragging and the mouse up is on the overlay
        if (isDragging && e.target === e.currentTarget && !disableBackdropClick) {
            onClose();
        }
        setIsDragging(false);
    };


    if (isOpen) {
        return (
            <div
                className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-75"
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <div
                    className={`flex flex-col justify-between bg-card rounded-lg shadow-lg px-6 pt-6 pb-6 w-[32%] max-md:w-[60%] relative max-h-[90vh] overflow-y-auto border-0 dark:border-2 dark:border-border ${className}`}
                    data-popup-panel
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Close "X" button */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-muted-foreground hover:text-muted-foreground transition-colors p-1"
                        aria-label="Close dialog"
                    >
                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="flex flex-1 items-start gap-1">
                        {/* SVG Icon on the left - only show if showIcon is true */}
                        {showIcon && (
                            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-4">
                                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                                </svg>
                            </div>
                        )}
                        <div className="flex-1">
                            <h3 className="text-base font-semibold text-foreground mb-1">{title}</h3>
                            <div className={contentClassName}>
                                {children}
                            </div>
                        </div>
                    </div>
                    {actionButton && (
                        <div className="flex justify-end gap-2 mt-6">
                            {actionButton}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return null;
}

export default DialogBox;